import { TabPanel, TabView } from 'primereact/tabview';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

import {
    selectCurrentEmpid,
    selectCurrentIsAdmin,
    selectCurrentIsEds,
    selectCurrentisComp,
} from '../../pages/login/authSlice';
import './delegate.scss';
import { useGetDelegateHistoryQuery } from './delegateSlice';
import { DelegateToForm } from './delegateToForm/DelegateToForm';
import { DelegateToHistory } from './delegateToHistory/DelegateToHistory';

type props = {
    index: number;
};

export const Delegate = ({ index }: props) => {
    const loggedEmpNum = useSelector(selectCurrentEmpid);
    const [activeIndex, setActiveIndex] = useState<any>(0);
    const isEds = useSelector(selectCurrentIsEds);
    const isAdmin = useSelector(selectCurrentIsAdmin);
    const isComp = useSelector(selectCurrentisComp);

    const { data: delegationHistory } = useGetDelegateHistoryQuery({
        employeenumber: loggedEmpNum,
        isDelegateTo: activeIndex !== 1,
    });

    useEffect(() => {
        setActiveIndex(index);
    }, [index]);

    return (
        <>
            <hr className="mt-0" />
            <TabView
                activeIndex={activeIndex}
                className="mt-3 delegateTabView"
                onTabChange={(e) => setActiveIndex(e.index)}
            >
                <TabPanel header="Delegate To" disabled={isEds || isAdmin || isComp}>
                    <DelegateToForm loggedEmpNum={loggedEmpNum} />

                    {delegationHistory !== undefined && (
                        <DelegateToHistory
                            loggedEmpNum={loggedEmpNum}
                            delegateHistory={delegationHistory}
                            activeIndex={activeIndex}
                        />
                    )}
                </TabPanel>
                <TabPanel header="Delegate To Me">
                    <DelegateToHistory
                        loggedEmpNum={loggedEmpNum}
                        delegateHistory={delegationHistory}
                        activeIndex={activeIndex}
                    />
                </TabPanel>
            </TabView>
        </>
    );
};
